import styled from 'styled-components';

export const ContentContainer = styled.div`
    display: flex;
    justify-content: center;
`;
export const Content = styled.div`
    padding: 0em 0em 3em 0em;
    @media (min-width: 500px) {
        padding: 0em 3em 8em 3em;
    }
    @media (min-width: 870px) {
        padding: 0em 8em 8em 8em;
    }
    @media (min-width: 1220px) {
        padding: 0em 12em 8em 12em;
        width: 1200px;
    }
    @media (min-width: 1400px) {
        padding: 0em 18em 8em 18em;
        width: 1700px;
    }
`;
export const Header = styled.h2`
    text-align: center;
    font-family: Lato-Bold;
    color: var(--main-teal-color);
    padding: 1em;
`;
export const InformationBlock = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
`;
export const SummaryBlock = styled.div`
    text-align: left;
    padding: 1em;
    @media (min-width: 1100px) {
        width: 40%;
    }
    @media (min-width: 703px) {
        text-align: right;
    }
`;
export const InfoHeader = styled.h3`
    font-family: Lato-Bold;
    color: var(--main-teal-color);
`;
export const Price = styled.span`
    font-family: Lato-Black;
    font-size: 2em;
    padding-right: 0.3em;
`;
